import { render, staticRenderFns } from "./actions-column-discounts.vue?vue&type=template&id=7a65be3e&scoped=true&"
import script from "./actions-column-discounts.vue?vue&type=script&lang=js&"
export * from "./actions-column-discounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65be3e",
  null
  
)

export default component.exports